var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgR1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.4667 17.35C10.3305 17.4472 10.1674 17.4994 10.0001 17.4994C9.83274 17.4994 9.66959 17.4472 9.53339 17.35C5.50923 14.4817 1.23839 8.58167 5.55589 4.31834C6.74078 3.15177 8.33728 2.49855 10.0001 2.5C11.6667 2.5 13.2659 3.15417 14.4442 4.3175C18.7617 8.58084 14.4909 14.48 10.4667 17.35Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.99894 9.99935C10.441 9.99935 10.8649 9.82375 11.1775 9.51119C11.49 9.19863 11.6656 8.77471 11.6656 8.33268C11.6656 7.89065 11.49 7.46673 11.1775 7.15417C10.8649 6.84161 10.441 6.66602 9.99894 6.66602C9.55691 6.66602 9.13299 6.84161 8.82043 7.15417C8.50787 7.46673 8.33228 7.89065 8.33228 8.33268C8.33228 8.77471 8.50787 9.19863 8.82043 9.51119C9.13299 9.82375 9.55691 9.99935 9.99894 9.99935Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgR1);
export default __webpack_public_path__ + "static/media/r1.e3e6180d6facc3685205ce13e81ceb9f.svg";
export { ForwardRef as ReactComponent };